import * as t from "io-ts";
import { RelevancyScore } from "../../../components/common";
import Avatar from "ui-components/avatar";
import { Tooltip, HTMLTable, Colors } from "@blueprintjs/core";
import { Box, Text, CustomCard, CustomTable } from "ui-components";
import { TableComponent } from "../../../components";
import { ReactElement } from "react";
import { styled } from "styled-components";

const TableColumnIdIO = t.union([
  t.literal("companyID"),
  t.literal("name"),
  t.literal("profileImage"),
  t.literal("foundersHighlights"),
  t.literal("companyName"),
  t.literal("industry"),
  t.literal("location"),
  t.literal("relevancyScore"),
  t.literal("companyHouseNo"),
]);
type TableColumnIdT = t.TypeOf<typeof TableColumnIdIO>;
export type CompanyT = Record<TableColumnIdT, any>;

const tableColumns: { id: TableColumnIdT; label: string }[] = [
  { id: "name", label: "Name" },
  { id: "foundersHighlights", label: "Founders Heighlights" },
  { id: "companyName", label: "Company Name" },
  { id: "industry", label: "Industry" },
  { id: "location", label: "Location" },
  { id: "relevancyScore", label: "Relevancy Score" },
  { id: "companyHouseNo", label: "Company House No." },
];

type Props = {
  handleCompanyDetails?: (company: CompanyT) => void;
  companyData?: CompanyT[];
  isStickyFirstColumn?: boolean;
};

const CompanyTableView = (props: Props) => {
  const { handleCompanyDetails, companyData, isStickyFirstColumn } = props;
  const data = companyData || [];

  return (
    <TableComponent mt={2} minHeight="270px">
      <CustomTable>
        <thead>
          <tr>
            {tableColumns.map(({ id, label }) => (
              <th
                key={id}
                style={{
                  fontWeight: "bolder",
                  textAlign: "left",
                }}
              >
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.companyID}>
              {tableColumns.map(({ id: columnId }) => (
                <td
                  key={row.companyID + columnId}
                  onClick={() =>
                    columnId === "name" &&
                    handleCompanyDetails &&
                    handleCompanyDetails(row)
                  }
                >
                  {columnId === "name" ? (
                    <span className="display-flex align-center cursor-pointer space-normal">
                      <Avatar
                        email={"yantrix@gmail.com"}
                        profileUrl={row?.profileImage || ""}
                        onlyAvatar={true}
                        displayName={row[columnId]}
                        isCircle={true}
                        isCurrentUser={false}
                        isLoading={false}
                        size={"30px"}
                      />
                      {row[columnId]}
                    </span>
                  ) : columnId === "relevancyScore" ? (
                    <RelevancyScore relevancyScore={row[columnId]} />
                  ) : (
                    row[columnId]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </CustomTable>
    </TableComponent>
  );
};

export default CompanyTableView;
